module.exports = __webpack_public_path__ + "static/media/Avenir-Black-03.968e7849.ttf";